export const FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST =
    'FETCH_PAYMENT_GATEWAY_CREDENTIALS_REQUEST';
export const FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS =
    'FETCH_PAYMENT_GATEWAY_CREDENTIALS_SUCCESS';
export const FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE =
    'FETCH_PAYMENT_GATEWAY_CREDENTIALS_FAILURE';

export const FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST =
    'FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_REQUEST';
export const FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR =
    'FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_ERROR';
export const FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS =
    'FETCH_PAYMENT_GATEWAY_CREDENTIAL_DATA_SUCCESS';

export const GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST =
    'GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST';
export const GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS =
    'GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS';
export const GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR =
    'GENERATE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR';

export const GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST =
    'GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST';
export const GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS =
    'GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS';
export const GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR =
    'GET_ACTIVE_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR';

export const DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST =
    'DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_REQUEST';
export const DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS =
    'DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_SUCCESS';
export const DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR =
    'DOWNLOAD_PAYMENT_GATEWAY_CREDENTIAL_REPORT_ERROR';

export const CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST =
    'CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST';
export const CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS =
    'CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS';
export const CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR =
    'CREATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR';

export const UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST =
    'UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_REQUEST';
export const UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS =
    'UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_SUCCESS';
export const UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR =
    'UPDATE_PAYMENT_GATEWAY_CREDENTIAL_STEP_ERROR';

export const RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM =
    'RESET_PAYMENT_GATEWAY_CREDENTIAL_CREATE_FORM';

export const RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM =
    'RESET_PAYMENT_GATEWAY_CREDENTIAL_EDIT_DATA_ON_CREATE_FORM';

export const RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM =
    'RESET_PAYMENT_GATEWAY_CREDENTIAL_UPDATE_FORM';

export const SHOW_ROLE_LOADER = 'SHOW_ROLE_LOADER';
export const HIDE_ROLE_LOADER = 'HIDE_ROLE_LOADER';

export const FETCH_FORM_DATA_PRICING_SECTION_REQUEST = 'FETCH_FORM_DATA_PRICING_SECTION_REQUEST';
export const FETCH_FORM_DATA_PRICING_SECTION_SUCCESS = 'FETCH_FORM_DATA_PRICING_SECTION_SUCCESS';
export const FETCH_FORM_DATA_PRICING_SECTION_FAILED = 'FETCH_FORM_DATA_PRICING_SECTION_FAILED';

export const CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM = 'CLICKED_CREATE_PAYMENT_CREADENTIAL_FORM';